import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import "../../Api/apiUrls.js";
import { API_URL, updateUser, getUserById, getPackageForAnnual } from "../../Api/apiUrls";
import PackageInvoice from "../../Components/instructor_comp/packageInvoice.js";

function ViewInstProfile() {
  const [userData, setUserData] = useState("");
  const [fullName, setFullName] = useState("");
  const [bio, setBio] = useState("");
  const [mobileNo, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [bankname, setBankName] = useState("");
  const [account, setAccount] = useState("");
  const [code, setCode] = useState("");
  const [pancard, setPanCard] = useState("");
  const [country, setCountry] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [twitter, setTwitter] = useState("");
  const [city, setCity] = useState("");
  const [youtube, setYoutube] = useState("");
  const [aadharcard, setAadharcard] = useState("");
  const [gstno, setGstno] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [file, setIconFile] = useState();
  const [modalPackageInvoiceIsOpen, setPackageInvoiceIsOpen] = useState(false);
  const [packageId, setPackageId] = useState("");
  const [packageName, setPackageName] = useState("");
  const [packageType, setPackageType] = useState("");
  const [holderName, setHolderName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  
  const [isEditable, setEditable] = useState(false);
  const [banknameEditable, setBanknameEditable] = useState(false);
  const [accountEditable, setAccountEditable] = useState(false);
  const [accountholderEditable, setAccountHolderEditable] = useState(false);
  const [codeEditable, setCodeEditable] = useState(false);
  const [gstEditable, setGstEditable] = useState(false);
  const [isReadOnly, setReadOnly] = useState(true);

  function reloadPage() {
    window.location.reload();
  }

  const openPackageInvoice = (idpackage, namepackage, typepackage) => {
    setPackageId(idpackage);
    setPackageName(namepackage);
    setPackageType(typepackage);
    setPackageInvoiceIsOpen(true);
  };

  const closePackageInvoice = () => {
    setPackageInvoiceIsOpen(false);
  };

  const userId = localStorage.getItem("user_id");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${getUserById}${userId}`);
        const data = await response.json();
        const user = data.data.user;
        
        setFullName(user.name || "");
        setIconFile(user.profile_image || "");
        setBio(user.bio || "");
        setMobile(user.mobileNumber || "");
        setAddress(user.address || "");
        setCity(user.city || "");
        setEmail(user.email || "");
        setCountry(user.country || "");
        setFacebook(user.facebook || "");
        setInstagram(user.instagram || "");
        setYoutube(user.youtube || "");
        setTwitter(user.twitter || "");
        setBankName(user.bank_name || "");
        setAccount(user.bank_account_number || "");
        setCode(user.bank_ifsc_code || "");
        setPanCard(user.pan_card_number || "");
        setAadharcard(user.aadhar_card_number || "");
        setGstno(user.gst_number || "");
        setBusinessName(user.business_name || "");
        setHolderName(user.account_holder_name || "");
        
        localStorage.setItem("userStatus", user.status || "");
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [userId]);

  const handleEditClick = () => {
    setEditable(true);
    setReadOnly(false);
    if (!bankname) setBanknameEditable(true);
    if (!account) setAccountEditable(true);
    if (!holderName) setAccountHolderEditable(true);
    if (!code) setCodeEditable(true);
    if (!gstno) setGstEditable(true);
  };

  const handleSaveClick = async () => {
    // Trim all string values to remove whitespace
    const trimmedName = fullName.trim();
    const trimmedEmail = email.trim();
  
    // // Validate required fields
    // if (!trimmedName) {
    //   alert("Full name is required and cannot be empty");
    //   return;
    // }
  
    if (!trimmedEmail || !trimmedEmail.includes("@")) {
      alert("Please enter a valid email address");
      return;
    }
  
    try {
      const formData = new FormData();
      formData.append("user_id", userId);
      
      // Always append name and email as they are required
      formData.append("name", trimmedName);
      formData.append("email", trimmedEmail);
  
      // For other fields, only append if they have value after trimming
      if (file) formData.append("profile_image", file);
      if (bio.trim()) formData.append("bio", bio.trim());
      if (mobileNo.trim()) formData.append("mobileNumber", mobileNo.trim());
      if (address.trim()) formData.append("address", address.trim());
      if (city.trim()) formData.append("city", city.trim());
      if (country.trim()) formData.append("country", country.trim());
      if (facebook.trim()) formData.append("facebook", facebook.trim());
      if (instagram.trim()) formData.append("instagram", instagram.trim());
      if (youtube.trim()) formData.append("youtube", youtube.trim());
      if (twitter.trim()) formData.append("twitter", twitter.trim());
      if (bankname.trim()) formData.append("bank_name", bankname.trim());
      if (account.trim()) formData.append("bank_account_number", account.trim());
      if (code.trim()) formData.append("bank_ifsc_code", code.trim());
      if (pancard.trim()) formData.append("pan_card_number", pancard.trim());
      if (aadharcard.trim()) formData.append("aadhar_card_number", aadharcard.trim());
      if (gstno.trim()) formData.append("gst_number", gstno.trim());
      if (businessName.trim()) formData.append("business_name", businessName.trim());
      if (holderName.trim()) formData.append("account_holder_name", holderName.trim());
  
      const response = await fetch(`${updateUser}`, {
        method: "PUT",
        body: formData,
      });
  
      if (!response.ok) {
        throw new Error(`Failed to save data: ${response.statusText}`);
      }
  
      const result = await response.json();
      console.log("Update result:", result);
  
      if (result.success) {
        alert("Profile updated successfully");
        // reloadPage();
        setEditable(false);
        setReadOnly(true);
      } else {
        throw new Error(result.message || "Failed to update profile");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      alert(error.message || "Failed to update profile. Please try again.");
    }
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIconFile(file);

    const reader = new FileReader();
    reader.onload = function(e) {
      const imgElement = document.getElementById("selectedImg");
      if (imgElement) {
        imgElement.src = e.target.result;
      }
    };
    reader.readAsDataURL(file);
  };

  const [packages, setPackages] = useState([]);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${getPackageForAnnual}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const activePackages = data.data.Package.filter(
          (pkg) => pkg.status === "Active"
        );
        setPackages(activePackages);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);

  const userStatus = localStorage.getItem("userStatus");

  if (isLoading) {
    return <div className="text-center py-5">Loading profile...</div>;
  }

  return (
    <div>
      {modalPackageInvoiceIsOpen && (
        <PackageInvoice 
          onClose={closePackageInvoice} 
          idpackage={packageId} 
          namepackage={packageName} 
          typepackage={packageType} 
        />
      )}
      <Header />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Profile</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li className="breadcrumb-item active">Profile</li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="card p-3">
            <div className="parent col-md-12 row mt-2">
              <div className="col-md-12" style={{ textAlign: "right" }}>
                <div className="child">
                  {!isEditable ? (
                    <button
                      id="btnNewUser"
                      type="button"
                      className="btn-round"
                      onClick={handleEditClick}
                    >
                      <i className="bi bi-pencil"></i> Edit Profile
                    </button>
                  ) : (
                    <button
                      id="btnSave"
                      type="button"
                      className="btn-round btn-primary"
                      onClick={handleSaveClick}
                    >
                      <i className="bi bi-save"></i> Save Changes
                    </button>
                  )}
                </div>
              </div>
            </div>
            <form style={{ padding: "0px 30px 30px 30px" }}>
              <div className="form-group">
                <label className="small mb-1" htmlFor="inputFullName">
                  Full Name<font color="red">*</font>
                </label>
                <input
                  className="form-control"
                  id="inputFullName"
                  type="text"
                  placeholder="Enter your full name"
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={fullName}
                  readOnly={isReadOnly}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
              </div>
              
              <div className="form-group">
                <label className="small mb-1" htmlFor="inputDocument">
                  Profile Image
                </label>
                <br />
                <input
                  type="file"
                  id="profileImage"
                  name="document"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  disabled={isReadOnly}
                />
                {file && (
                  <img
                    id="selectedImg"
                    src={typeof file === 'string' ? `${API_URL}/${file}` : URL.createObjectURL(file)}
                    alt="Profile"
                    style={{ width: "100px", height: "100px", marginTop: "10px", borderRadius: "50%" }}
                  />
                )}
              </div>
              
              <div className="form-group">
                <label className="small mb-1" htmlFor="inputBio">
                  Bio
                </label>
                <textarea
                  className="form-control"
                  id="inputBio"
                  type="text"
                  placeholder="Tell us about yourself"
                  style={{ height: "100px", pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={bio}
                  readOnly={isReadOnly}
                  onChange={(e) => setBio(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputNo">
                      Mobile No.
                    </label>
                    <input
                      className="form-control"
                      id="inputNo"
                      type="text"
                      placeholder="Enter mobile number"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={mobileNo}
                      readOnly={isReadOnly}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputEmail">
                      Email<font color="red">*</font>
                    </label>
                    <input
                      className="form-control"
                      id="inputEmail"
                      type="email"
                      placeholder="Enter your email"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={email}
                      readOnly={isReadOnly}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="small mb-1" htmlFor="inputAddress">
                  Address
                </label>
                <input
                  className="form-control"
                  id="inputAddress"
                  type="text"
                  placeholder="Enter your address"
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={address}
                  readOnly={isReadOnly}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputCity">
                      City
                    </label>
                    <input
                      className="form-control"
                      id="inputCity"
                      type="text"
                      placeholder="Enter city"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={city}
                      readOnly={isReadOnly}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputCountry">
                      Country
                    </label>
                    <input
                      className="form-control"
                      id="inputCountry"
                      type="text"
                      placeholder="Enter country"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={country}
                      readOnly={isReadOnly}
                      onChange={(e) => setCountry(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <h5 className="mt-4 mb-3">Bank Details</h5>
              
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputBankName">
                      Branch & Bank Name
                    </label>
                    <input
                      className="form-control"
                      id="inputBankName"
                      type="text"
                      value={bankname}
                      placeholder="Enter bank name"
                      style={{ pointerEvents: banknameEditable ? "auto" : "none" }}
                      readOnly={!banknameEditable}
                      onChange={(e) => setBankName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputAccount">
                      Account No.
                    </label>
                    <input
                      className="form-control"
                      id="inputAccount"
                      type="text"
                      placeholder="Enter account number"
                      value={account}
                      style={{ pointerEvents: accountEditable ? "auto" : "none" }}
                      readOnly={!accountEditable}
                      onChange={(e) => setAccount(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputHolderName">
                      Account Holder Name
                    </label>
                    <input
                      className="form-control"
                      id="inputHolderName"
                      type="text"
                      placeholder="Enter account holder name"
                      value={holderName}
                      style={{ pointerEvents: accountholderEditable ? "auto" : "none" }}
                      readOnly={!accountholderEditable}
                      onChange={(e) => setHolderName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputIfsc">
                      IFSC Code
                    </label>
                    <input
                      className="form-control"
                      id="inputIfsc"
                      type="text"
                      placeholder="Enter IFSC code"
                      value={code}
                      style={{ pointerEvents: codeEditable ? "auto" : "none" }}
                      readOnly={!codeEditable}
                      onChange={(e) => setCode(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <h5 className="mt-4 mb-3">Identification Details</h5>
              
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputPan">
                      PAN Card No.
                    </label>
                    <input
                      className="form-control"
                      id="inputPan"
                      type="text"
                      placeholder="Enter PAN number"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={pancard}
                      readOnly={isReadOnly}
                      onChange={(e) => setPanCard(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputAadhar">
                      Aadhar Card No.
                    </label>
                    <input
                      className="form-control"
                      id="inputAadhar"
                      type="text"
                      placeholder="Enter Aadhar number"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={aadharcard}
                      readOnly={isReadOnly}
                      onChange={(e) => setAadharcard(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputGst">
                      GST No.
                    </label>
                    <input
                      className="form-control"
                      id="inputGst"
                      type="text"
                      placeholder="Enter GST number"
                      value={gstno}
                      style={{ pointerEvents: gstEditable ? "auto" : "none" }}
                      readOnly={!gstEditable}
                      onChange={(e) => setGstno(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputBusiness">
                      Business Name
                    </label>
                    <input
                      className="form-control"
                      id="inputBusiness"
                      type="text"
                      placeholder="Enter business name"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={businessName}
                      readOnly={isReadOnly}
                      onChange={(e) => setBusinessName(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <h5 className="mt-4 mb-3">Social Media Links</h5>
              
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputFacebook">
                      Facebook
                    </label>
                    <input
                      className="form-control"
                      id="inputFacebook"
                      type="text"
                      placeholder="Enter Facebook URL"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={facebook}
                      readOnly={isReadOnly}
                      onChange={(e) => setFacebook(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputInstagram">
                      Instagram
                    </label>
                    <input
                      className="form-control"
                      id="inputInstagram"
                      type="text"
                      placeholder="Enter Instagram URL"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={instagram}
                      readOnly={isReadOnly}
                      onChange={(e) => setInstagram(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputYoutube">
                      YouTube
                    </label>
                    <input
                      className="form-control"
                      id="inputYoutube"
                      type="text"
                      placeholder="Enter YouTube URL"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={youtube}
                      readOnly={isReadOnly}
                      onChange={(e) => setYoutube(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputTwitter">
                      Twitter
                    </label>
                    <input
                      className="form-control"
                      id="inputTwitter"
                      type="text"
                      placeholder="Enter Twitter URL"
                      style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                      value={twitter}
                      readOnly={isReadOnly}
                      onChange={(e) => setTwitter(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              {isEditable && (
                <div className="form-group text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-primary btn-lg"
                    onClick={handleSaveClick}
                  >
                    Save Changes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-lg ml-3"
                    onClick={() => {
                      setEditable(false);
                      setReadOnly(true);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </form>

            {userStatus === 'Inactive' && (
              <div className="row col-md-12 mt-5">
                <div className="col-12">
                  <h5 className="mb-4">Buy Package for Annual Hosting</h5>
                </div>
                {packages.map((packageItem) => (
                  <div key={packageItem.id} className="col-md-4 mb-4">
                    <div className="card h-100" style={{ boxShadow: "0px 0 30px rgba(1, 41, 112, 0.1)" }}>
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title">
                          <b>{packageItem.name}</b>
                        </h5>
                        <p className="card-text">Price: ₹{packageItem.price}</p>
                        <p className="card-text">Duration: {packageItem.duration} days</p>
                        <div className="mt-auto">
                          <button
                            className="btn btn-dark w-100"
                            onClick={() =>
                              openPackageInvoice(packageItem.id, packageItem.name, packageItem.type)
                            }
                          >
                            Buy Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ViewInstProfile;